window.KEYCODES = {
    TAB: 9,
    ESC: 27,
    DOWN: 40,
    RIGHT: 39,
    UP: 38,
    LEFT: 37,
    RETURN: 13
};

/* ================ INIT THEME SLIDERS ================ */
function initSliders() {
    //========= Collection Slider Js [Global Js] =========
    // if ($('.collection-slider').length > 0) {
    //     var collection_swiper = new Swiper(".collection-slider", {
    //         slidesPerView: 4,
    //         spaceBetween: 20,
    //         loop: true,
    //         pagination: {
    //             el: ".collection-slider .swiper-pagination",
    //             clickable: true,
    //         },
    //         navigation: {
    //             nextEl: ".collection-slider-btn-main .swiper-button-next",
    //             prevEl: ".collection-slider-btn-main .swiper-button-prev",
    //         },
    //         breakpoints: {
    //             1025: {
    //                 slidesPerView: 4,
    //             },
    //             701: {
    //                 slidesPerView: 3,
    //             },
    //             370: {
    //                 slidesPerView: 2,
    //             },
    //             250: {
    //                 slidesPerView: 1,
    //             },
    //         },
    //     });
    // }

    //========= Hero Slider Js [Home Page] =========
   
    if (document.querySelector('.new-hero-carousel')) {
        const sliderContainer = document.querySelector('.new-hero-carousel');

        const autoplaySetting = sliderContainer.dataset.autoplay === 'true';
        const delaySetting = (parseInt(sliderContainer.dataset.delay))*1000;

        console.log("Autoplay:", autoplaySetting, "| Delay:", delaySetting);

        const swiperOptions = {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            pagination: {
                el: ".new-hero-carousel .swiper-pagination",
                clickable: true,
            },
        };

        if (autoplaySetting) {
            swiperOptions.autoplay = {
                delay: delaySetting
            };
        }

        const newHeroSwiper = new Swiper(".new-hero-carousel", swiperOptions);
    }

    //========= Hero Slider Js End =========


    //========= Mid Image Slider Js =========
    if ($('.mid-image-carousel').length > 0) {
        var mid_image_swiper = new Swiper(".mid-image-carousel", {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: ".mid-image-carousel .swiper-button-next",
                prevEl: ".mid-image-carousel .swiper-button-prev",
            },
        });
    }

    //========= Product Media Slider Js =========
    if ($('.pdp-hero-slider-thum').length > 0) {
        var pdpHeroSliderThum = new Swiper(".pdp-hero-slider-thum", {
            spaceBetween: 12,
            slidesPerView: 5.4,
            freeMode: true,
            watchSlidesProgress: true,
        });
        var pdpHeroSlider = new Swiper(".pdp-hero-slider", {
            spaceBetween: 10,
            slidesPerView: 1,
            thumbs: {
                swiper: pdpHeroSliderThum,
            },
        });
    }
}

/* ================ Recommendation Slider Start ================ */
function recommendationSlider() {
    console.log("Recommendation Slider Init...");
    new Swiper("#recommendation-slider", {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        pagination: {
            el: "#recommendation-slider .swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: "#recommendation-slider-btn-main .swiper-button-next",
            prevEl: "#recommendation-slider-btn-main .swiper-button-prev",
        },
        breakpoints: {
            1025: {
                slidesPerView: 4,
            },
            701: {
                slidesPerView: 3,
            },
            370: {
                slidesPerView: 2,
            },
            250: {
                slidesPerView: 1,
            },
        },
    });
}
/* ================ Recommendation Slider End ================ */

/* ================ Cart Recommendation Slider Start ================ */
window.cartRecommendation = () => {
    if ($('.product-like-slider').length > 0) {
        new Swiper(".product-like-slider", {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 10,
            speed: 600,
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
        });
    }
}
/* ================ Cart Recommendation Slider end ================ */

/* ================ Product swatches start ================ */
function selectVariant() {
    let productVariantsScript = document.querySelector('script[type="application/json"][data-product-variants]');

    if (!productVariantsScript) return;

    let productVariants = JSON.parse(productVariantsScript.textContent);
    let my_options = [];
    document.querySelectorAll('.swatch-wrapper input[type="radio"]:checked')?.forEach(option => {
        my_options.push(option.value)
    });
    const variant = productVariants.find(variant =>
        my_options.every(value => variant.options.includes(value))
    );

    if (variant) renderProductInfo(variant);
}

function renderProductInfo(variant) {
    const requestedVariantId = variant.id;
    const swatchWrapper = document.querySelector(".swatch-wrapper");

    if (!swatchWrapper) return;

    const sectionId = swatchWrapper.dataset.section;
    const productURL = swatchWrapper.dataset.url;

    fetch(`${productURL}?variant=${requestedVariantId}&section_id=${sectionId}`)
        .then(res => res.text())
        .then(html => {
            window.history.replaceState({}, "", `${productURL}?variant=${variant.id}`);

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");

            const form = document.querySelector(`#product-form-${sectionId}`);
            if (form && form.querySelector('[name="id"]')) form.querySelector('[name="id"]').value = requestedVariantId;

            const price = doc.querySelector(`.pdp-price-${sectionId}`);
            const priceTarget = document.querySelector(`.pdp-price-${sectionId}`);
            if (price && priceTarget) priceTarget.innerHTML = price.innerHTML;

            const atc = doc.querySelector(`.pdp-atc-${sectionId}`);
            const atcTarget = document.querySelector(`.pdp-atc-${sectionId}`);
            if (atc && atcTarget) atcTarget.innerHTML = atc.innerHTML;

            const offerContent = doc.querySelector(`.offer-content-${sectionId}`);
            const offerContentTarget = document.querySelector(`.offer-content-${sectionId}`);
            if (offerContent && offerContentTarget) offerContentTarget.innerHTML = offerContent.innerHTML;

            const inStock = doc.querySelector(`.pdp-stock-info-${sectionId}`);
            const inStockTarget = document.querySelector(`.pdp-stock-info-${sectionId}`);
            if (inStock && inStockTarget) inStockTarget.innerHTML = inStock.innerHTML;

            const progressBar = doc.querySelector(`#progress_bar_data-${sectionId}`);
            const progressBarTarget = document.querySelector(`#progress_bar_data-${sectionId}`);
            if (progressBar && progressBarTarget) {
                const innerBar = progressBar.querySelector("#progress_product_bar");
                const targetBar = progressBarTarget.querySelector("#progress_product_bar");
                if (innerBar && targetBar) targetBar.innerHTML = innerBar.innerHTML;
            }

            if (variant.featured_media) {
                const f_id = variant.featured_media.id;
                const imageEle = document.querySelector(`img[data-img="${f_id}"]`);
                const swiper = document.querySelector(".pdp-hero-slider").swiper;

                if (imageEle && swiper) {
                    const slides = swiper.slides;
                    const slideIndex = Array.prototype.findIndex.call(
                        slides,
                        slide => slide.contains(imageEle)
                    );
                    if (slideIndex !== -1) {
                        swiper.slideTo(slideIndex, 250, false, true);
                    }
                }
            }
        })
        .catch(err => console.error("error", err));
}
/* ================ Product swatches end ================ */

function updateErrors(message) {
    $('[data-line-error]').html(message);
    setTimeout(() => {
        $('[data-line-error]').html();
    }, 2000);
}

/* ================ Add to cart form start ================ */
async function sendItemToCart(var_id, quantity, formElement, errDiv) {
    event.preventDefault();
    if (formElement.reportValidity()) {
        let formData = new FormData(formElement);
        formData.append('sections_url', window.location.pathname);
        formData.append('sections', 'cart-drawer,header');

        let data = await fetch(window.routes.root_url + 'cart/add.js', {
            headers: {
                'Accept': 'application/javascript',
                'X-Requested-With': "XMLHttpRequest"
            },
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            if (data['message']) {
                if (errDiv) {
                    errDiv.innerText = data['message'];
                    setTimeout(() => {
                        errDiv.style.display = 'none';
                    }, 2000);
                }
            } else {
                console.log('Add to cart initiated...');
                const parser = new DOMParser(),
                    newCartHTML = parser.parseFromString(data.sections['cart-drawer'], 'text/html'),
                    newHeaderHTML = parser.parseFromString(data.sections['header'], 'text/html');

                $(`[data-cart="cart-drawer"]`).html($(newCartHTML).find(`[data-cart="cart-drawer"]`).html());
                if (typeof window.cartRecommendation != 'undefined') window.cartRecommendation();
                $(`header .cart-count`).html($(newHeaderHTML).find(`.cart-count`).html());

                const cartDrawerWrapper = document.querySelector('sidebar-drawer');
                if (cartDrawerWrapper && cartDrawerWrapper.classList.contains('cart-is-empty')) {
                    cartDrawerWrapper.classList.remove('cart-is-empty');
                }
                cartDrawerWrapper.show();
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });

    } else {
        for (let element of formElement.elements) {
            if (element.validationMessage) {
                element.style.border = "1px solid red";
                console.log(`${element.name} error: ${element.validationMessage}`);
            }
        }
        toggle_cart.classList.remove("active");
    }
}

/* ================ Update Cart start ================ */
function updateCart(_this, line, quantity, section_id) {
    const body = JSON.stringify({
        line,
        quantity,
        sections: section_id,
        sections_url: window.location.pathname,
    });

    fetch(window.routes.cart_change_url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            },
            body
        })
        .then(async (response) => {
            const text = await response.text();
            let parsedState;
            try {
                parsedState = JSON.parse(text);
            } catch (e) {
                updateErrors('Failed to parse server response');
                throw e;
            }

            if (!response.ok) {
                const errorMessage = parsedState.message || parsedState.errors || parsedState.error || window.cartStrings.error;
                updateErrors(errorMessage);
                throw new Error(errorMessage);
            }

            return parsedState;
        })
        .then(parsedState => {
            const quantityElement = $(`#quantity-${line}`),
                parser = new DOMParser(),
                newCartHTML = parser.parseFromString(parsedState.sections[section_id], 'text/html'),
                items = document.querySelectorAll('[data-line-item]');

            if (parsedState.errors) {
                updateErrors(parsedState.errors);
                return;
            }

            $(`[data-cart="${section_id}"]`).html($(newCartHTML).find(`[data-cart="${section_id}"]`).html());
            if (typeof window.cartRecommendation !== 'undefined') window.cartRecommendation();
            $(`header .cart-count`).html(parsedState.item_count);

            const cartDrawerWrapper = document.querySelector('sidebar-drawer');
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('cart-is-empty', parsedState.item_count === 0);
        })
        .finally(() => {
            console.log('Cart update completed...');
        });
}

/* ================ Update cart end ================ */
if (Shopify.designMode) {
    $(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
        initSliders();
    });
}

$(document).ready(function(e) {
    initSliders();
    if (typeof window.cartRecommendation != 'undefined') window.cartRecommendation();

    //========= Header Sticky Js [Global Js] =========
    $(window).scroll(function() {
        if ($(this).scrollTop() > 50) {
            $('header.site-header').addClass('header-sticky');
        } else {
            $('header.site-header').removeClass('header-sticky');
        }
    });

    //========= Header space add in site wrapper [Global Js] =========
    function headerspace() {
        var headerHeight = $('header.site-header').outerHeight() || 0;
        $('.site-wrapper').css("padding-top", headerHeight);
    }
    headerspace();
    $(window).on("load", headerspace);
    $(window).on("resize orientationchange", headerspace);

    //========= Mobile Menu Js [For Mobile Js] =========
    if ($(window).width() < 992) {
        //========= Open Menu in Mobile [For Mobile Js] =========
        $("body").on("click", ".mob-menu-btn", function() {
            $(this).toggleClass('active-btn');
            $('.main-menu').toggleClass('open');
            $('body').toggleClass('overlay-hidden');
        });

        //========= Open Menu Dropdown in Mobile [For Mobile Js] =========
        $("body").on("click", ".main-menu nav .nav-item:has(.dropdown-menu) .nav-link, .mob-menu-btn", function(e) {
            e.preventDefault();
            $('.main-menu nav .nav-item:has(.dropdown-menu) .nav-link').removeClass('active');
            $('.main-menu nav .nav-item:has(.dropdown-menu) .nav-link').next().slideUp();
            if (!$(this).next('.dropdown-menu').is(':visible')) {
                $(this).next('.dropdown-menu').slideDown();
                $(this).addClass('active');
            }
        });

        //========= Search Bar Open [Global Js] =========
        $("body").on("click", ".header-right-content .search .search-btn, .header-right-content .search .search-close", function(e) {
            e.preventDefault();
            $(".header-right-content .search .search-btn").toggleClass("search_open");
        });
    }

    //========= Open Footer Menu in Mobile [For Mobile Js] =========
    if ($(window).width() < 769) {
        $("body").on("click", ".footer-content .footer-menu .footer-quick-link h6", function(e) {
            e.preventDefault();
            $('.footer-content .footer-menu .footer-quick-link h6').removeClass('active');
            $('.footer-content .footer-menu .footer-quick-link h6').next().slideUp();
            if (!$(this).next('.footer-content .footer-menu .footer-quick-link ul').is(':visible')) {
                $(this).next('.footer-content .footer-menu .footer-quick-link ul').slideDown();
                $(this).addClass('active');
            }
        });
    }


    /* ================ FAQ section JS Start ================ */
    $("body").on("click", ".faq-tab-header", function(f) {
        f.preventDefault();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".faq-tab-body").slideUp(300);
        } else {
            $(this)
                .parents(".main-faq-inner")
                .find(".faq-tab-header")
                .removeClass("active");
            $(this).addClass("active");
            $(this).parents(".main-faq-inner").find(".faq-tab-body").slideUp(300);
            $(this).siblings(".faq-tab-body").slideDown(300);
        }
    });
    /* ================ FAQ section JS End ================ */


    //========= Stock Info Hide-Show [PDP Page] =========
    $("body").on("click", ".info_icon", function(e) {
        e.preventDefault();
        $(".stock-info").slideToggle();
    });

    //========= Cart item remove =========
    $("body").on("click", "[data-line-remove]", function(e) {
        e.preventDefault();
        const rootItem = $(this).parents("[data-line-item]"),
            line = rootItem.data("index"),
            section_id = rootItem.data('section');
        updateCart($(this), line, 0, section_id);
    });

    //========= Cart item update =========
    $("body").on("click", "[data-line-quantity] button", function(e) {
        e.preventDefault();
        const rootItem = $(this).parents("[data-line-item]"),
            line = rootItem.data("index"),
            section_id = rootItem.data('section'),
            line_input = $(this).parent().find('input');

        let line_value = parseInt(line_input.val());
        line_value = $(this).hasClass('cart-plus') ? (line_value + 1) : (line_value - 1);

        updateCart($(this), line, line_value, section_id);
    });
});

// ===============================================================================
// ================================== Dev Start ==================================
// ===============================================================================

document.addEventListener("DOMContentLoaded", function(e) {
    document.body.addEventListener('click', function(e) {
        // pagination target
        const paginateClick = e.target.closest(".pagination-wrapper ul li a, .pagination-wrapper .pag-arrow-btn a");

        if (e.target.closest('.minus')) { // quantity decrease
            let qtyGet = parseInt(e.target.closest('.pdp-hero-right-qty').querySelector('[name="quantity"]').value)
            qtyGet--
            qtyGet = qtyGet < 1 ? 1 : qtyGet;
            e.target.closest('.pdp-hero-right-qty').querySelector('[name="quantity"]').value = qtyGet;

        } else if (e.target.closest('.plus')) { // quantity increase
            let qtyGet = parseInt(e.target.closest('.pdp-hero-right-qty').querySelector('[name="quantity"]').value)
            qtyGet++
            e.target.closest('.pdp-hero-right-qty').querySelector('[name="quantity"]').value = qtyGet;

        } else if (e.target.closest('.add-to-cart')) { // product add to cart
            e.preventDefault();
            let wrap = e.target.closest('.main-pro-wrap'),
                varId = wrap.querySelector('[name="id"]')?.value,
                qty = wrap.querySelector('[name="quantity"]')?.value,
                formEl = wrap.querySelector('.product-form'),
                errDiv = wrap.querySelector('.err-message');
            sendItemToCart(varId, qty, formEl, errDiv);

        } else if (e.target.closest('.main-product-like-slider .upsell-add-cart')) {
            const button = e.target.closest('.main-product-like-slider .upsell-add-cart');
            if (button) {
                e.preventDefault();

                const form = button.closest('form'),
                    varIdInput = form.querySelector('[name="id"]'),
                    varId = varIdInput ? varIdInput.value : null,
                    qty = 1;

                sendItemToCart(varId, qty, form);
            }

        } else if (paginateClick) { // pagination click
            e.preventDefault();
            const url = paginateClick.getAttribute("href"),
                sectionWrapper = paginateClick.closest(".pagination-wrapper"),
                sectionId = sectionWrapper ? sectionWrapper.getAttribute("data-section-id") : null;

            if (!url || !sectionId) return;

            fetch(url)
                .then((res) => res.text())
                .then((data) => {
                    window.history.replaceState({}, "", url);
                    const doc = new DOMParser().parseFromString(data, "text/html"),
                        // replaceContent = doc.querySelector(`.collection-slider-${sectionId}`), 
                        // currentWrapper = document.querySelector(`.collection-slider-${sectionId}`);
                        replaceContent = doc.querySelector(`.pagination-container-${sectionId}`),
                        currentWrapper = document.querySelector(`.pagination-container-${sectionId}`);
                    if (replaceContent && currentWrapper) {
                        currentWrapper.innerHTML = replaceContent.innerHTML;
                    }

                    const pagination = doc.querySelector(".pagination-wrapper"),
                        currentPagination = document.querySelector(`.pagination-wrapper-${sectionId}`);
                    if (pagination && currentPagination) {
                        currentPagination.innerHTML = pagination.innerHTML;
                    }
                })
                .catch((err) => {
                    console.log("error pagination: ", err);
                });
        } else {}
    })
    document.querySelectorAll('.swatch-wrapper input[type="radio"]')?.forEach(radio => {
        radio.addEventListener("change", () => {
            selectVariant();
        });
    });

    // =============== Price Ranger Start ==========================
    const rangeInput = document.querySelectorAll(".range-input input"),
        minPriceDisplay = document.querySelector(".min-price-display"),
        maxPriceDisplay = document.querySelector(".max-price-display"),
        range = document.querySelector(".input-slider .input-progress"),
        minRange = rangeInput[0],
        maxRange = rangeInput[1];

    function updateSliderTrack(minVal, maxVal) {
        range.style.left = (minVal / minRange.max) * 100 + "%";
        range.style.right = 100 - (maxVal / maxRange.max) * 100 + "%";
    }

    function priceRangeFilter() {
        if (minPriceDisplay && rangeInput.length) {
            let priceGap = 10;
            // Initialize values
            let minVal = parseInt(minRange.value),
                maxVal = parseInt(maxRange.value);
            updateSliderTrack(minVal, maxVal);
            minPriceDisplay.textContent = minVal;
            maxPriceDisplay.textContent = maxVal;
            // Min range input event
            minRange.addEventListener("input", () => {
                minVal = parseInt(minRange.value);
                maxVal = parseInt(maxRange.value);
                if (minVal > maxVal - priceGap) {
                    minRange.value = maxVal - priceGap;
                    minVal = parseInt(minRange.value);
                }
                minPriceDisplay.textContent = minVal;
                updateSliderTrack(minVal, maxVal);
            });
            // Max range input event
            maxRange.addEventListener("input", () => {
                minVal = parseInt(minRange.value);
                maxVal = parseInt(maxRange.value);
                if (maxVal < minVal + priceGap) {
                    maxRange.value = minVal + priceGap;
                    maxVal = parseInt(maxRange.value);
                }
                maxPriceDisplay.textContent = maxVal;
                updateSliderTrack(minVal, maxVal);
            });
        } else {}
    }
    priceRangeFilter();

    // =============== Price Ranger End ==========================

    // =============== SORT FILTERS ==============================
    const filterForm = document.querySelector("facet-form");

    if(filterForm){
        const sortRadios = document.querySelectorAll('.sort_list-wrapper input[name="sort_by"]');
        const productGrid = document.querySelector(".main-collection-wrapper");
        const sectionId = productGrid.dataset.sectionid;
        const applyBtn = document.querySelector("#apply");
        const updateCollection = (url) => {
            fetch(url.toString(), {
                    headers: {
                        "X-Requested-With": "XMLHttpRequest"
                    }
                })
                .then(res => res.text())
                .then(html => {
                    const doc = new DOMParser().parseFromString(html, "text/html");
                    const newGrid = doc.querySelector(".main-collection-wrapper");
                    document.querySelector(".filter-bar").innerHTML = doc.querySelector(".filter-bar").innerHTML
                    document.querySelector(".main-filter-sidebar-bottom .main-filter-checklist").innerHTML = doc.querySelector(".main-filter-sidebar-bottom .main-filter-checklist").innerHTML
                    // console.log(doc.querySelector(".filter-bar").innerHTML)
                    if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
                    url.searchParams.delete("section_id");
                    window.history.pushState({}, "", url);
                    document.querySelector('.main-sort-sidebar').classList.remove('is-open')
                    document.querySelector('.main-filter-sidebar').classList.remove('is-open')
                    document.querySelector('.collection-overlay').classList.remove('is-open')
                    document.body.style.overflow = 'visible';
                })
                .catch(err => {
                    console.error("Error updating collection:", err);
                });
        };

        const buildURL = () => {
            const currentUrl = new URL(window.location.href);
            const url = new URL(window.location.pathname, window.location.origin);
            url.searchParams.set("section_id", sectionId);

            if (currentUrl.searchParams.has("q")) {
                url.searchParams.set("q", currentUrl.searchParams.get("q"));
            }

            const inputs = filterForm.querySelectorAll("input[type='checkbox']:checked");
            inputs.forEach(input => {
                url.searchParams.append(input.name, input.value);
            });

            const minRange = filterForm.querySelector(".range-min");
            const maxRange = filterForm.querySelector(".range-max");
            if (minRange && minRange.value) url.searchParams.set(minRange.name, minRange.value);
            if (maxRange && maxRange.value) url.searchParams.set(maxRange.name, maxRange.value);

            const activeSort = document.querySelector('.sort_list-wrapper input[name="sort_by"]:checked');
            if (activeSort) url.searchParams.set("sort_by", activeSort.value);
            return url;
        };

        // sort change
        sortRadios.forEach(radio => {
            radio.addEventListener("change", function() {
                // console.log("Sorting changed:", this.value, sectionId);
                const url = buildURL();
                url.searchParams.set("sort_by", this.value);
                updateCollection(url);
            });
        });

        if (applyBtn) {
            applyBtn.addEventListener("click", function(e) {
                e.preventDefault();
                const url = buildURL();
                updateCollection(url);
            });
        }

        window.addEventListener("popstate", () => {
            const url = new URL(window.location.href);
            updateCollection(url);
        });

    }
    // =============== SORT FILTERS END ==========================


    // ======================= Filter and Sort Drawer Start ================================
    let overlay = document.querySelector('.collection-overlay');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'collection-overlay';
        document.body.appendChild(overlay);
    }

    function getPanels() {
        const scope = document.querySelector('.main-collection-filter-section');
        if (!scope) return {
            filterPanel: null,
            sortPanel: null
        };

        return {
            filterPanel: scope.querySelector('.main-filter-sidebar'),
            sortPanel: scope.querySelector('.main-sort-sidebar')
        };
    }

    function openPanel(panel) {
        if (!panel) return;
        panel.classList.add('is-open');
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
    }

    function closePanel(panel) {
        if (!panel) return;
        const {
            filterPanel,
            sortPanel
        } = getPanels();

        panel.classList.remove('is-open');

        if (![filterPanel, sortPanel].some(p => p && p.classList.contains('is-open'))) {
            overlay.classList.remove('is-open');
            document.body.style.overflow = '';
        }
    }

    document.addEventListener('click', function(event) {
        const target = event.target;
        const {
            filterPanel,
            sortPanel
        } = getPanels();

        if (target.closest('.filter-btn')) {
            openPanel(filterPanel);
            return;
        }
        if (target.closest('.sort-btn')) {
            openPanel(sortPanel);
            return;
        }
        if (filterPanel && (target.closest('.filter-sidebar-close') || target.closest('.filter-sidebar-btn-close'))) {
            if (filterPanel.contains(target)) {
                closePanel(filterPanel);
                return;
            }
        }
        if (sortPanel && target.closest('.sort-sidebar-close')) {
            if (sortPanel.contains(target)) {
                closePanel(sortPanel);
                return;
            }
        }
    });

    overlay.addEventListener('click', () => {
        const {
            filterPanel,
            sortPanel
        } = getPanels();
        closePanel(filterPanel);
        closePanel(sortPanel);
    });
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            const {
                filterPanel,
                sortPanel
            } = getPanels();
            closePanel(filterPanel);
            closePanel(sortPanel);
        }
    });
    // =========================  Filter and Sort Drawer End ==============================
});


class KlaviyoReviewCount extends HTMLElement {
    constructor() {
        super(),
            this.observer = null
    }
    connectedCallback() {
        this.startObserving(),
            this.updateReviewLabel()
    }
    disconnectedCallback() {
        this.stopObserving()
    }
    startObserving() {
        if (!this.observer) {
            const config = {
                childList: !0,
                subtree: !0,
                characterData: !0,
                attributes: !1
            };
            this.observer = new MutationObserver(this.handleMutations.bind(this)),
                this.observer.observe(this, config)
        }
    }
    stopObserving() {
        this.observer && (this.observer.disconnect(),
            this.observer = null)
    }
    handleMutations(mutationsList, observer) {
        const reviewLabel = this.querySelector(".kl_reviews__star_rating_widget__label");
        reviewLabel && this.performTextTransformation(reviewLabel) && this.stopObserving()
    }
    updateReviewLabel() {
        const reviewLabel = this.querySelector(".kl_reviews__star_rating_widget__label");
        reviewLabel && this.performTextTransformation(reviewLabel)
    }
    performTextTransformation(reviewLabel) {
        const currentText = reviewLabel.textContent.trim();
        if (currentText.toLowerCase().includes("review")) {
            const match = currentText.match(/^(\d+)/);
            if (match) {
                const number = match[1];
                return reviewLabel.textContent = `(${number})`,
                    !0
            }
        }
        return !0
    }
}
customElements.define("klaviyo-star-tkolab", KlaviyoReviewCount);